import { networkService } from "services/networkService";
import {
  METHOD_HIS_RELEASE_VERSION_LIST,
  METHOD_HIS_RELEASE_VERSION_CREATE,
  METHOD_HIS_RELEASE_VERSION_UPDATE,
  METHOD_HIS_RELEASE_VERSION_DELETE,
  METHOD_HIS_RELEASE_VERSION_DETAIL,

  // mapping page
  METHOD_HISMAPPER_LIST,
  METHOD_HIS_COMBINE_KEY_CREATE,
  METHOD_HIS_COMBINE_KEY_DELETE,
  METHOD_CPU_GEN_MAPPING_KEY_CREATE,
  METHOD_CPU_GEN_MAPPING_KEY_DETAILS,
  METHOD_CPU_GEN_MAPPING_KEY_UPDATE,
  METHOD_CPU_GEN_MAPPING_KEY_DELETE,
  METHOD_CPLD_MAPPING_KEY_CREATE,
  METHOD_CPLD_MAPPING_KEY_DETAILS,
  METHOD_CPLD_MAPPING_KEY_UPDATE,
  METHOD_CPLD_MAPPING_KEY_DELETE,
  METHOD_BIOS_MAPPING_KEY_CREATE,
  METHOD_BIOS_MAPPING_KEY_DETAILS,
  METHOD_BIOS_MAPPING_KEY_DELETE,
  METHOD_NIC_MAPPING_KEY_CREATE,
  METHOD_NIC_MAPPING_KEY_DETAILS,
  METHOD_NIC_MAPPING_KEY_DELETE,
  METHOD_HBA_MAPPING_KEY_CREATE,
  METHOD_HBA_MAPPING_KEY_DETAILS,
  METHOD_HBA_MAPPING_KEY_UPDATE,
  METHOD_HBA_MAPPING_KEY_DELETE,
  METHOD_CONTROLLER_MAPPING_KEY_CREATE,
  METHOD_CONTROLLER_MAPPING_KEY_DETAILS,
  METHOD_CONTROLLER_MAPPING_KEY_UPDATE,
  METHOD_CONTROLLER_MAPPING_KEY_DELETE,
  METHOD_GPU_MAPPING_KEY_CREATE,
  METHOD_GPU_MAPPING_KEY_DETAILS,
  METHOD_GPU_MAPPING_KEY_DELETE,

  METHOD_FC_SWITCH_MAPPING_KEY_CREATE,
  METHOD_FC_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_LEAF_SWITCH_MAPPING_KEY_CREATE,
  METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_SPINE_SWITCH_MAPPING_KEY_CREATE,
  METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_CREATE,
  METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS,
  METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DELETE,
  METHOD_FC_SWITCH_MAPPING_KEY_DELETE,
  METHOD_LEAF_SWITCH_MAPPING_KEY_DELETE,
  METHOD_SPINE_SWITCH_MAPPING_KEY_DELETE,
  METHOD_FIRMWARE_BY_SWITCH,
  METHOD_DRIVE_MAPPING_KEY_CREATE,
  METHOD_DRIVE_MAPPING_KEY_DETAILS,
  METHOD_DRIVE_MAPPING_KEY_UPDATE,
  METHOD_DRIVE_MAPPING_KEY_DELETE,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_CREATE,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_DETAILS,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_UPDATE,
  METHOD_BLOCK_STORAGE_MAPPING_KEY_DELETE, 
  METHOD_EXTRA_MAPPING_KEY_CREATE,
  METHOD_EXTRA_MAPPING_KEY_DETAILS,
  METHOD_EXTRA_MAPPING_KEY_UPDATE,
  METHOD_EXTRA_MAPPING_KEY_DELETE,
} from "constants/admin/masters/his";

class HisService {
  masters = [
    { id: 1, name: 'HIS Combine Key' },
    { id: 5, name: 'CPU Generation', masterSlug: 'cpu_generation' },
    { id: 17, name: 'BIOS/BMC' },
    { id: 4, name: 'CPLD', masterSlug: 'cpld' },
    { id: 3, name: 'Controller', masterSlug: 'controller' },
    { id: 13, name: 'NIC', masterSlug: 'nic' },
    { id: 10, name: 'HBA', masterSlug: 'hba' },
    { id: 9, name: 'GPU', masterSlug: 'gpu' },
    { id: 6, name: 'Drive', masterSlug: 'drive' },
    { id: 8, name: 'FC Switch', masterSlug: 'fc_switch' },
    { id: 2, name: 'Block Storage', masterSlug: 'block_storage' },
    { id: 11, name: 'Leaf Switch', masterSlug: 'leaf_switch' },
    { id: 16, name: 'Spine Switch', masterSlug: 'spine_switch' },
    { id: 12, name: 'Management Switch', masterSlug: 'management_switch' },
    { id: 7, name: 'Extra', masterSlug: 'extra' }
  ];

  getAllHis = () => {
    return new Promise((resolve, reject) => {
      resolve({
        total: 16,
        items: this.masters
      })
    })
  };
  getAllHisReleaseVersion = (data) => {
    return networkService
      .post(METHOD_HIS_RELEASE_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getHisReleaseVersionDetail = (id) => {
    const updatedMethodName = METHOD_HIS_RELEASE_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createHisReleaseVersion = (data) => {
    return networkService
      .post(METHOD_HIS_RELEASE_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  updateHisReleaseVersion = (data, id) => {
    const updatedMethodName = METHOD_HIS_RELEASE_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteHisReleaseVersion = (id, is_delete = false) => {
    const updatedMethodName = METHOD_HIS_RELEASE_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName, { data: { is_delete } })
      .then((response) => response.data);
  };

  // start new code
  // his master mapping 
  getAllInitialData = (masterId) => {

    const methodName = METHOD_HISMAPPER_LIST.replace("{masterId}", masterId)
    return networkService
      .get(methodName)
      .then((response) => response.data);

  }
  // combine key creation 
  createCombinekey = (data) => {
    return networkService
      .post(METHOD_HIS_COMBINE_KEY_CREATE, data)
      .then((response) => response.data);
  };

  // combine key deletion 
  deleteHisCombineKey = (id) => {
    const deleteMethodName = METHOD_HIS_COMBINE_KEY_DELETE.replace("{ID}", id);
    return networkService
      .delete(deleteMethodName)
      .then((response) => response.data);
  };


  // his CPU generation mapping creation
  createCPUGenerationMapping = (data) => {
    return networkService
      .post(METHOD_CPU_GEN_MAPPING_KEY_CREATE, data)
      .then((response) => response.data);

  };
  //  his CPU generation edit item details 
  getCPUGenKeyDetails = (ID) => {
    let replaceName = METHOD_CPU_GEN_MAPPING_KEY_DETAILS.replace("{ID}", ID)
    return networkService.get(replaceName)
      .then((response) => response.data)
  }
  //  his CPU generation update 
  updateCPUGenMapping = (ID, data) => {
    let replaceName = METHOD_CPU_GEN_MAPPING_KEY_UPDATE.replace("{ID}", ID);
    return networkService
      .post(replaceName, data)
      .then((response) => response.data);

  };
  //  his CPU generation deletion 
  deleteCPUGenMapping = (id) => {
    const deleteMethodName = METHOD_CPU_GEN_MAPPING_KEY_DELETE.replace("{ID}", id);
    return networkService
      .delete(deleteMethodName)
      .then((response) => response.data);
  };
   //his CPLD mapping creation 
     createCPLDMapping= (data) => {
      return networkService
        .post(METHOD_CPLD_MAPPING_KEY_CREATE, data)
        .then((response) => response.data);
  
    };
    //  his CPLD edit item details 
   getCPLDKeyDetails = (ID) =>{
    let replaceName = METHOD_CPLD_MAPPING_KEY_DETAILS.replace("{ID}", ID)
    return networkService.get(replaceName)
    .then((response)=> response.data)
  }
    //  his CPLD mapping update 
    updateCPLDMapping= (ID,data) => {
      let replaceName = METHOD_CPLD_MAPPING_KEY_UPDATE.replace("{ID}", ID);
      return networkService
        .post(replaceName, data)
        .then((response) => response.data);
  
    };
  
    //  his CPLD mapping  deletion 
    deleteCPLDMapping = (id) => {
      const deleteMethodName = METHOD_CPLD_MAPPING_KEY_DELETE.replace("{ID}", id);
      return networkService
        .delete(deleteMethodName)
        .then((response) => response.data);
    };


    // bios/bmc
    createBiosBmcMapping = (data) => {
      return networkService
      .post(METHOD_BIOS_MAPPING_KEY_CREATE, data)
      .then(response => response.data);
    };
    
    getBiosMappingDetails = (id) => {
      const mappingDetailsUrl = METHOD_BIOS_MAPPING_KEY_DETAILS.replace("{ID}", id)
      return networkService.get(mappingDetailsUrl)
        .then((response) => response.data);
    };
    
    updateBiosMappingById = (id, updatedData) => {
      const mappingDetailsUrl = METHOD_BIOS_MAPPING_KEY_DETAILS.replace("{ID}", id)
      return networkService.post(mappingDetailsUrl, updatedData)
        .then((response) => response.data)
    };
    
    deleteBiosMappingById = (id) => {
      const mappingDetailsUrl = METHOD_BIOS_MAPPING_KEY_DELETE.replace("{ID}", id)
      return networkService.delete(mappingDetailsUrl)
        .then((response) => response.data)
    };

    // nic
    createNicMapping = (data) => {
      return networkService
      .post(METHOD_NIC_MAPPING_KEY_CREATE, data)
      .then(response => response.data);
    };
    
    getNicMappingDetails = (id) => {
      const mappingDetailsUrl = METHOD_NIC_MAPPING_KEY_DETAILS.replace("{ID}", id)
      return networkService.get(mappingDetailsUrl)
        .then((response) => response.data);
    };
    
    updateNicMappingById = (id, updatedData) => {
      const mappingDetailsUrl = METHOD_NIC_MAPPING_KEY_DETAILS.replace("{ID}", id)
      return networkService.post(mappingDetailsUrl, updatedData)
        .then((response) => response.data)
    };
    
    deleteNicMappingById = (id) => {
      const mappingDetailsUrl = METHOD_NIC_MAPPING_KEY_DELETE.replace("{ID}", id)
      return networkService.delete(mappingDetailsUrl)
        .then((response) => response.data)
    };
    //  his hba mapping creation
    createHbaMapping=(data) => {
      return networkService
        .post(METHOD_HBA_MAPPING_KEY_CREATE, data)
        .then((response) => response.data);
    };
    //  get his hba edit item details 
    getHbaKeyDetails = (ID) =>{
      let replaceName = METHOD_HBA_MAPPING_KEY_DETAILS.replace("{ID}", ID)
      return networkService.get(replaceName)
      .then((response)=> response.data)
    }
     //  his hba update 
    updateHbaMapping= (ID,data) => {
      let replaceName = METHOD_HBA_MAPPING_KEY_UPDATE.replace("{ID}", ID);
      return networkService
        .post(replaceName, data)
        .then((response) => response.data);
    
    };
    //  his hba deletion 
    deleteHbaMapping = (id) => {
      const deleteMethodName = METHOD_HBA_MAPPING_KEY_DELETE.replace("{ID}", id);
      return networkService
        .delete(deleteMethodName)
        .then((response) => response.data);
    };
    //  his controller mapping creation
    createControllerMapping=(data) => {
      return networkService
        .post(METHOD_CONTROLLER_MAPPING_KEY_CREATE, data)
        .then((response) => response.data);
    };
    //  get his controller edit item details 
    getControllerKeyDetails = (ID) =>{
      let replaceName = METHOD_CONTROLLER_MAPPING_KEY_DETAILS.replace("{ID}", ID)
      return networkService.get(replaceName)
      .then((response)=> response.data)
    }
     //  his controller update 
    updateControllerMapping= (ID,data) => {
      let replaceName = METHOD_CONTROLLER_MAPPING_KEY_UPDATE.replace("{ID}", ID);
      return networkService
        .post(replaceName, data)
        .then((response) => response.data);
    
    };
    //  his controller deletion 
    deleteControllerMapping = (id) => {
      const deleteMethodName = METHOD_CONTROLLER_MAPPING_KEY_DELETE.replace("{ID}", id);
      return networkService
        .delete(deleteMethodName)
        .then((response) => response.data);
    };
    // his gpu
    
      createGpuMapping = (data) => {
        return networkService
          .post(METHOD_GPU_MAPPING_KEY_CREATE, data)
          .then((response) => response.data);
      };
    
      getGpuMappingDetails = (id) => {
        const mappingDetailsUrl = METHOD_GPU_MAPPING_KEY_DETAILS.replace("{ID}", id)
        return networkService.get(mappingDetailsUrl)
          .then((response) => response.data)
      };
    
      updateGpuMappingById= (id, updatedData) => {
        const mappingDetailsUrl = METHOD_GPU_MAPPING_KEY_DETAILS.replace("{ID}", id)
        return networkService.post(mappingDetailsUrl, updatedData)
          .then((response) => response.data)
      };
    
      deleteGpuMappingById= (id) => {
        const mappingDetailsUrl = METHOD_GPU_MAPPING_KEY_DELETE.replace("{ID}", id)
        return networkService.delete(mappingDetailsUrl)
          .then((response) => response.data)
      };
      // *****SWITCHES******
       // his FC Switch
        createFcSwitchMapping = (data) => {
          return networkService
            .post(METHOD_FC_SWITCH_MAPPING_KEY_CREATE, data)
            .then((response) => response.data);
        };
      
        getFcSwitchMappingDetails = (id) => {
          const mappingDetailsUrl = METHOD_FC_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.get(mappingDetailsUrl)
            .then((response) => response.data)
        };
      
        updateFcSwitchMappingById= (id, updatedData) => {
          const mappingDetailsUrl = METHOD_FC_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.post(mappingDetailsUrl, updatedData)
            .then((response) => response.data)
        };
      
        deleteFcSwitchMappingById= (id) => {
          const mappingDetailsUrl = METHOD_FC_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
          return networkService.delete(mappingDetailsUrl)
            .then((response) => response.data)
        };
      
        // his leaf Switch
        createLeafSwitchMapping = (data) => {
          return networkService
            .post(METHOD_LEAF_SWITCH_MAPPING_KEY_CREATE, data)
            .then((response) => response.data);
        };
      
        // his leaf switch
        getLeafSwitchMappingDetails = (id) => {
          const mappingDetailsUrl = METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.get(mappingDetailsUrl)
            .then((response) => response.data)
        };
      
        updateLeafSwitchMappingById= (id, updatedData) => {
          const mappingDetailsUrl = METHOD_LEAF_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.post(mappingDetailsUrl, updatedData)
            .then((response) => response.data)
        };
      
        deleteLeafSwitchMappingById= (id) => {
          const mappingDetailsUrl = METHOD_LEAF_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
          return networkService.delete(mappingDetailsUrl)
            .then((response) => response.data)
        };
      
      
        // his spine Switch
        createSpineSwitchMapping = (data) => {
          return networkService
            .post(METHOD_SPINE_SWITCH_MAPPING_KEY_CREATE, data)
            .then((response) => response.data);
        };
      
        getSpineSwitchMappingDetails = (id) => {
          const mappingDetailsUrl = METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.get(mappingDetailsUrl)
            .then((response) => response.data)
        };
      
        updateSpineSwitchMappingById= (id, updatedData) => {
          const mappingDetailsUrl = METHOD_SPINE_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.post(mappingDetailsUrl, updatedData)
            .then((response) => response.data)
        };
      
        deleteSpineSwitchMappingById= (id) => {
          const mappingDetailsUrl = METHOD_SPINE_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
          return networkService.delete(mappingDetailsUrl)
            .then((response) => response.data)
        };
      
        
        // his management Switch
        createManagementSwitchMapping = (data) => {
          return networkService
            .post(METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_CREATE, data)
            .then((response) => response.data);
        };
      
        getManagementSwitchMappingDetails = (id) => {
          const mappingDetailsUrl = METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.get(mappingDetailsUrl)
            .then((response) => response.data)
        };
      
        updateManagementSwitchMappingById= (id, updatedData) => {
          const mappingDetailsUrl = METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DETAILS.replace("{ID}", id)
          return networkService.post(mappingDetailsUrl, updatedData)
            .then((response) => response.data)
        };
      
        deleteManagementSwitchMappingById= (id) => {
          const mappingDetailsUrl = METHOD_MANAGEMENT_SWITCH_MAPPING_KEY_DELETE.replace("{ID}", id)
          return networkService.delete(mappingDetailsUrl)
            .then((response) => response.data)
        };

        // get firmware corresponding to selected switch
          getFirmwareBySwitch = (productId, switchId) => {
            const url = METHOD_FIRMWARE_BY_SWITCH?.replace('{product_id}', productId)
              .replace('{switch_id}', switchId);
            return networkService
              .get(url)
              .then(response => response?.data);
          }

          // his drive mapping creation
          createDriveMapping=(data) => {
            console.log("createDriveMapping funcion is called", data);
            return networkService
              .post(METHOD_DRIVE_MAPPING_KEY_CREATE, data)
              .then((response) => response.data);
          
          };
          //  get his drive edit item details 
          getDriveKeyDetails = (ID) =>{
            let replaceName = METHOD_DRIVE_MAPPING_KEY_DETAILS.replace("{ID}", ID)
            return networkService.get(replaceName)
            .then((response)=> response.data)
          }
           //  his drive update 
          updateDriveMapping= (ID,data) => {
            let replaceName = METHOD_DRIVE_MAPPING_KEY_UPDATE.replace("{ID}", ID);
            return networkService
              .post(replaceName, data)
              .then((response) => response.data);
          
          };
          //  his drive deletion 
          deleteDriveMapping = (id) => {
            const deleteMethodName = METHOD_DRIVE_MAPPING_KEY_DELETE.replace("{ID}", id);
            return networkService
              .delete(deleteMethodName)
              .then((response) => response.data);
          };
    //** his block storage methods**/ 
    //  his block storage mapping creation
    createBlockStorageMapping=(data) => {
      return networkService
        .post(METHOD_BLOCK_STORAGE_MAPPING_KEY_CREATE, data)
        .then((response) => response.data);
    };
    //  get his block storage edit item details 
    getBlockStorageKeyDetails = (ID) =>{
      let replaceName = METHOD_BLOCK_STORAGE_MAPPING_KEY_DETAILS.replace("{ID}", ID)
      return networkService.get(replaceName)
      .then((response)=> response.data)
    }
     //  his block storage update 
    updateBlockStorageMapping= (ID,data) => {
      let replaceName = METHOD_BLOCK_STORAGE_MAPPING_KEY_UPDATE.replace("{ID}", ID);
      return networkService
        .post(replaceName, data)
        .then((response) => response.data);
    
    };
    //  his block storage deletion 
    deleteBlockStorageMapping = (id) => {
      const deleteMethodName = METHOD_BLOCK_STORAGE_MAPPING_KEY_DELETE.replace("{ID}", id);
      return networkService
        .delete(deleteMethodName)
        .then((response) => response.data);
    };      
    // extra
    createExtraMapping = (data) => {
      return networkService
      .post(METHOD_EXTRA_MAPPING_KEY_CREATE, data)
      .then(response => response.data);
    };
    
    getExtraMappingDetails = (id) => {
      const mappingDetailsUrl = METHOD_EXTRA_MAPPING_KEY_DETAILS.replace("{ID}", id)
      return networkService.get(mappingDetailsUrl)
        .then((response) => response.data);
    };
    
    updateExtraMappingById = (id, updatedData) => {
      const mappingDetailsUrl = METHOD_EXTRA_MAPPING_KEY_UPDATE.replace("{ID}", id)
      return networkService.post(mappingDetailsUrl, updatedData)
        .then((response) => response.data)
    };
    
    deleteExtraMappingById = (id) => {
      const mappingDetailsUrl = METHOD_EXTRA_MAPPING_KEY_DELETE.replace("{ID}", id)
      return networkService.delete(mappingDetailsUrl)
        .then((response) => response.data)
    };
    
}
export default HisService;
